// John Eldhose 20190212
import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import { lmdprint } from '../Api/lmdprint';
import { ServiceCenterAddress } from './lib/LMD';

class LMDPrint extends Component {

  state = {
    rma: window.location.search.replace(/^[?]/, ''),
    loading: true,
    data: []
  }
  componentWillMount() {
    lmdprint({ rma: this.state.rma })
      .then((rpt) => {
        this.setState({ data: rpt.data, loading: false });
        window.print();
      })
      .catch(() => {
        this.setState({ loading: false });
      })
  }
  ServiceCenter = () => {
    const $sc = ServiceCenterAddress[this.state.data.ServiceCenter].split('\n');
    $sc[0] = '<b>' + $sc[0] + '</b>'
    return $sc.join('<br />');
  }

  render() {
    if(this.state.loading)
      return (
        <div style={{ textAlign: 'center' }}>
          <style>{'body { background: #fff; }'}</style>
          <div style={{ height: '200px' }}>&nbsp;</div>
          <CircularProgress />
        </div>
      );
    else {
      return (
        <div>
          <style>{'div { line-height: 1.3; }'}</style>
          <style>{'body { font-size: 14pt; line-height: 15pt; background: #fff; }'}</style>
          <style>{'table { border-collapse: collapse; }'}</style>
          <style>{'hr { margin: 0px; padding: 0px }'}</style>
          <style>{'@media print { body { font-size: 12pt; } }'}</style>
          <table width='100%' border='0' cellPadding='0' cellSpacing='0'>
            <thead>
              <tr>
                <th colSpan='2' style={{ textAlign: 'left' }}>
                  <font size='5'>LMD</font><br />
                  <font size='5'>Returned Materials Authorisation</font>
                </th>
                <th width='33%'>
                  <img src='LMDlogo.png' width='100%' alt='LMD' height='100%'/>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan='3' style={{ textAlign: 'right' }}>
                  <b>RMA Date:</b> { this.state.data.date }<br />
                  <b>RMA Number:</b> { this.state.data.ixBug }<br />
                  <b>Contact:</b> { this.state.data.ContactName }<br />
                  <b>Service User Contact: E- Mail:</b> { this.state.data.ContactEMail } <br />
                  <b>Send Quote to Contact: E- Mail:</b> { this.state.data.BillingEMail }
                </td>
              </tr>
              <tr><td colSpan='3'><hr /></td></tr>
              <tr><td colSpan='3' style={{ padding: '7px' }}></td></tr>
              <tr>
                <td colSpan='2'><b>Bill To</b></td>
                <td><b>Ship To</b></td>
              </tr>
              <tr><td colSpan='3' style={{ padding: '2px' }}></td></tr>
              <tr>
                <td colSpan='2' valign='top'>
                  { this.state.data.CompanyName }<br />
                  { this.state.data.BillingAddress }<br />
                  { this.state.data.BillingCity }, { this.state.data.BillingState } { this.state.data.BillingZip }<br />
                  { this.state.data.BillingCountry }<br />
                  { this.state.data.BillingEMail }
                </td>
                <td valign='top'>
                  { this.state.data.CompanyName }<br />
                  { this.state.data.ShippingAddress }<br />
                  { this.state.data.ShippingCity }, { this.state.data.ShippingState } { this.state.data.ShippingZip }<br />
                  { this.state.data.ShippingCountry }
                </td>
              </tr>
              <tr><td colSpan='3' style={{ padding: '2px' }}></td></tr>
              <tr><td colSpan='3'><hr size='1' /></td></tr>
              <tr>
                <td colSpan='3'>
                  <font size='2' style={{ lineHeight: '22pt' }}>
                    Please send all equipment to the address listed below.
                  </font>
                </td>
              </tr>
              <tr>
                <td colSpan='3'>
                  <div
                    dangerouslySetInnerHTML={{ __html: this.ServiceCenter() }}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan='3'>
                  <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                  <font size='2'>
                    * You are advised to return all goods in their original packaging/transit casing. *<br />
                    * If you are claiming under warranty, you will need to provide proof of purchase. *<br />
                    * Please include a copy of this completed RMA document with the returned goods. Terms and Conditions Apply.*
                  </font>
                  </div>
                </td>
              </tr>
              <tr><td colSpan='3'><hr size='1' /></td></tr>
              <tr><td colSpan='3' style={{ padding: '12px' }}></td></tr>
              <tr>
                <td width='33%'><b>Product</b></td>
                <td><b>Serial Number</b></td>
                <td><b>Freight Insurance</b></td>
              </tr>
              <tr><td colSpan='3' style={{ padding: '2px' }}></td></tr>
              <tr>
                <td>{ this.state.data.Product }</td>
                <td>{ this.state.data.SerialNumber }</td>
                <td>${ this.state.data.FreightInsurance } <small>USD</small></td>
              </tr>
              <tr><td colSpan='3' style={{ padding: '7px' }}></td></tr>
              <tr><td colSpan='3'><hr size='1' /></td></tr>
              <tr><td colSpan='3' style={{ padding: '7px' }}></td></tr>
              <tr><td colSpan='3'><b>RMA Description</b></td></tr>
              <tr><td colSpan='3' style={{ padding: '2px' }}></td></tr>
              <tr><td colSpan='3'>{ this.state.data.sTitle }</td></tr>
              <tr><td colSpan='3' style={{ padding: '7px' }}></td></tr>
              <tr><td colSpan='3'><hr size='1' /></td></tr>
              <tr><td colSpan='3' style={{ padding: '7px' }}></td></tr>
              <tr><td colSpan='3'><b>Fauilt Description</b></td></tr>
              <tr><td colSpan='3' style={{ padding: '2px' }}></td></tr>
              <tr><td colSpan='3'>{ this.state.data.body }</td></tr>
            </tbody>
          </table>
        </div>
      );
    }
  }
}

export default LMDPrint;



// WEBPACK FOOTER //
// ./src/components/LMDPrint.js